export default __webpack_public_path__ + "static/media/fast.28f19d3a.svg";